import { useState, useCallback } from 'react';
import { pw9213Api } from '../../../services/pw9213Api';
import { F913, F9131 } from '../../../services/pw9213Api';

export function usePW9213Lookup() {
  const [names, setNames] = useState<Record<string, string>>({});

  const resolveSingleName = useCallback(async (nameKey: string, type: string, code: string) => {
    const name = await pw9213Api.lookupName(type, code);
    setNames(prev => ({ ...prev, [nameKey]: name }));
  }, []);

  const resolveAllNames = useCallback(async (master: Partial<F913>, firstDetail?: Partial<F9131>) => {
    const entries: [string, string, string][] = [
      ['employee', 'employee', master.f913_01 || ''],
    ];
    if (firstDetail?.f9131_03) {
      entries.push(['leaveType', 'leaveType', firstDetail.f9131_03]);
    }
    const results = await Promise.all(
      entries.map(([key, type, code]) =>
        pw9213Api.lookupName(type, code).then(name => [key, name] as [string, string])
      )
    );
    setNames(prev => {
      const next = { ...prev };
      for (const [key, name] of results) next[key] = name;
      return next;
    });
  }, []);

  const clearNames = useCallback(() => {
    setNames({});
  }, []);

  return { names, resolveSingleName, resolveAllNames, clearNames };
}
